import { fetchWell } from "../api/sewage";
import { PointLayer } from '@antv/l7'

export default {

    methods: {
        getWell() {
            if (!this.sewageWellLayer) {
                fetchWell({}).then((res) => {
                    if (res && Array.isArray(res.locs)) {
                        const list = Object.freeze(res.locs);

                        const zoom = this.map?.getZoom() || 3;

                        this.sewageWellLayer = new PointLayer({
                            zIndex: 100,
                        })

                            .source(list.map(item => {
                                return {
                                    id: item[0],
                                    type: item[1],
                                    x: item[3],
                                    y: item[4],
                                }
                            }), {
                                parser: {
                                    type: 'json',
                                    x: 'x',
                                    y: 'y'
                                }
                            })
                            .shape('sewageWell')
                            .size(zoom * 0.55)

                        this.sewageWellLayer.on('click', this.onSewageWellClick)

                        this.scene?.addLayer(this.sewageWellLayer);


                    }
                });



            } else {
                this.sewageWellLayer.show();
            }
        },

        onSewageWellClick(e) {
            console.log('e', e)
            if (this.addStatus === 'facility') {
                const { id, x, y } = e.feature;

                this.addFacility({
                    id,
                    type: 'well',
                    category: 'sewage',
                    x: parseFloat(x),
                    y: parseFloat(y)
                })
            }

        },

        removeWell() {
            this.sewageWellLayer?.hide();
        },


    }
}

